import React from 'react';

const portfolioItems = [
  {
    id: 1,
    image: '/assets/images/ecom-web/portfolio (1).jpg',
    title: 'Abrelia Home Aesthetics',
    category: 'Furniture & Decor',
    platform: 'Custom Shopify'
  },
  {
    id: 2,
    image: '/assets/images/ecom-web/portfolio (2).jpg',
    title: 'Vape Cloud Store',
    category: 'Lifestyle & Vape',
    platform: 'Shopify Plus'
  },
  {
    id: 3,
    image: '/assets/images/ecom-web/portfolio (3).jpg',
    title: 'Radion Tech & Electronics',
    category: 'Consumer Electronics',
    platform: 'Magento Commerce'
  },
  {
    id: 4,
    image: '/assets/images/ecom-web/portfolio (4).jpg',
    title: 'Luxrio Time Travel Watches',
    category: 'Luxury Watches',
    platform: 'WooCommerce'
  },
  {
    id: 5,
    image: '/assets/images/ecom-web/portfolio (5).jpg',
    title: 'LeKate Tech Platform',
    category: 'Digital Products',
    platform: 'Headless Next.js'
  },
  {
    id: 6,
    image: '/assets/images/ecom-web/portfolio (6).jpg',
    title: 'Sweet Pink Apparel',
    category: 'Fashion & Apparel',
    platform: 'Shopify Store'
  },
  {
    id: 7,
    image: '/assets/images/ecom-web/portfolio (7).jpg',
    title: 'Old Smoky Distillers',
    category: 'Beverages & Spirits',
    platform: 'BigCommerce'
  },
  {
    id: 8,
    image: '/assets/images/ecom-web/portfolio (8).jpg',
    title: 'Azenko Modern Store',
    category: 'Creative Goods',
    platform: 'Wix eCommerce'
  }
];

function EcommercePortfolio() {
  const handleConsultationClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('ecommerce-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="ecom-portfolio-section">
      <div className="container">
        {/* Section Header */}
        <div className="ecom-portfolio-header">
          <div className="ecom-portfolio-badge-row">
            <span className="ecom-portfolio-badge">Featured Work & Storefronts</span>
            <div className="ecom-portfolio-badge-line"></div>
          </div>

          <h2 className="ecom-portfolio-title">
            E-commerce Store <span className="text-red">Development Portfolio</span>
          </h2>

          <p className="ecom-portfolio-subtitle">
            Explore our curated showcase of high-converting online stores built for modern brands. Hover over any storefront to explore full page layout from top to bottom.
          </p>
        </div>

        {/* Portfolio 4-Column Grid */}
        <div className="ecom-portfolio-grid">
          {portfolioItems.map((item) => (
            <div key={item.id} className="ecom-portfolio-card" onClick={handleConsultationClick}>
              {/* Browser Window Frame Header */}
              <div className="ecom-portfolio-window-bar">
                <div className="ecom-window-dots">
                  <span className="ecom-dot dot-red"></span>
                  <span className="ecom-dot dot-yellow"></span>
                  <span className="ecom-dot dot-green"></span>
                </div>
                <span className="ecom-window-title">{item.platform}</span>
              </div>

              {/* Scrollable Image Frame */}
              <div className="ecom-portfolio-img-frame">
                <img 
                  src={item.image} 
                  alt={item.title} 
                  className="ecom-portfolio-img"
                  loading="lazy"
                />

                {/* Hover Hint Overlay */}
                <div className="ecom-hover-hint">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="7 13 12 18 17 13" />
                    <polyline points="7 6 12 11 17 6" />
                  </svg>
                  <span>Auto-scrolling</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default EcommercePortfolio;
